import { useCallback } from "react";
import { useCachedQuery } from "./useCachedQuery";
import { fetchTenantHealthHistory, type TenantHealthTimeline } from "./useAdminStatus";
import { instanceHealthResource } from "../lib/adminQueries";
import { rangeToWindowHours, type InstanceRange } from "../lib/instanceDetailRange";

export type InstanceHealthResult = {
  status: "loading" | "ready" | "error";
  timeline: TenantHealthTimeline | null;
  error: string | null;
  isFetching: boolean;
};

export const useInstanceHealth = (tenantId: string, range: InstanceRange): InstanceHealthResult => {
  const hours = rangeToWindowHours(range);
  const fetcher = useCallback(
    (signal: AbortSignal): Promise<TenantHealthTimeline> => fetchTenantHealthHistory(tenantId, hours, signal),
    [tenantId, hours],
  );
  const { status, data, error, isFetching } = useCachedQuery<TenantHealthTimeline>({
    cacheResource: range === "24h" ? instanceHealthResource(tenantId) : null,
    queryKey: `/api/admin/claws/${tenantId}/health-history?hours=${hours}`,
    fetcher,
  });
  return { status, timeline: data, error, isFetching };
};
